"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NavigationMenuButton_component_exports = {};
__export(NavigationMenuButton_component_exports, {
  NavigationMenuButtonCtx: () => NavigationMenuButtonCtx,
  default: () => NavigationMenuButton_component_default
});
module.exports = __toCommonJS(NavigationMenuButton_component_exports);
var import_react = __toESM(require("react"));
var import_react_popper = require("react-popper");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_NavigationMenuItem = require("./NavigationMenuItem.component");
var import_NavigationMenuButton = require("./NavigationMenuButton.styled");
var import_utils = require("../../../themes/utils");
var _excluded = ["disabled", "darkMode", "placeholder", "listBoxPlacement"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var NavigationMenuButtonContext = /* @__PURE__ */ (0, import_react.createContext)(void 0);
var NavigationMenuButtonCtx = function NavigationMenuButtonCtx2() {
  var ctx = (0, import_react.useContext)(NavigationMenuButtonContext);
  if (!ctx)
    throw new Error("This must be used within <NavigationMenuButton> component");
  return ctx;
};
var NavigationMenuButton = function NavigationMenuButton2(_ref) {
  var _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Select an option" : _ref$placeholder, _ref$listBoxPlacement = _ref.listBoxPlacement, listBoxPlacement = _ref$listBoxPlacement === void 0 ? "bottom" : _ref$listBoxPlacement, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(null), _useState4 = _slicedToArray(_useState3, 2), selected = _useState4[0], setSelected = _useState4[1];
  var menuButtonContainerRef = (0, import_react.useRef)(null);
  var menuRef = (0, import_react.useRef)(null);
  var menuButtonRef = (0, import_react.useRef)(null);
  var _useState5 = (0, import_react.useState)(), _useState6 = _slicedToArray(_useState5, 2), navMenuItems = _useState6[0], setNavMenuItems = _useState6[1];
  var _useState7 = (0, import_react.useState)(-1), _useState8 = _slicedToArray(_useState7, 2), currentMenuItemPosition = _useState8[0], setCurrentMenuItemPosition = _useState8[1];
  var _usePopper = (0, import_react_popper.usePopper)(menuButtonRef.current, menuRef.current, {
    placement: listBoxPlacement,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 5]
      }
    }]
  }), styles = _usePopper.styles, attributes = _usePopper.attributes, update = _usePopper.update;
  var dataContext = (0, import_react.useMemo)(function() {
    return {
      open,
      setOpen,
      id: props.id,
      selected,
      setSelected,
      currentMenuItemPosition,
      maxVisibleChars: props.maxVisibleChars
    };
  }, [open, props.id, selected, currentMenuItemPosition, props.maxVisibleChars]);
  (0, import_react.useLayoutEffect)(function() {
    if (open) {
      if (update) {
        update();
      }
    }
  }, [open]);
  (0, import_useOnKeydown.useOnKeydown)(menuButtonRef, function(keyList, ev) {
    var Enter = keyList.Enter, Space = keyList[" "], ArrowUp = keyList.ArrowUp, ArrowDown = keyList.ArrowDown, Escape = keyList.Escape, Tab = keyList.Tab;
    if (Enter || ArrowDown || Space) {
      ev.preventDefault();
      setOpen(true);
      setCurrentMenuItemPosition(0);
      setTimeout(function() {
        return navMenuItems[0].focus();
      }, 200);
    }
    if (ArrowUp) {
      ev.preventDefault();
      setOpen(true);
      setCurrentMenuItemPosition(navMenuItems.length - 1);
      setTimeout(function() {
        return navMenuItems[navMenuItems.length - 1].focus();
      }, 200);
    }
    if (Escape || Tab) {
      setOpen(false);
    }
    ev.stopPropagation();
  });
  var setFocusOnNavButton = function setFocusOnNavButton2() {
    menuButtonRef.current.focus();
  };
  (0, import_useOnKeydown.useOnKeydown)(menuRef, function(keyList, ev) {
    var Escape = keyList.Escape, ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, Tab = keyList.Tab, Home = keyList.Home, End = keyList.End, Space = keyList[" "];
    var navMenuItemsBoundary;
    if (navMenuItems && navMenuItems.length) {
      navMenuItemsBoundary = navMenuItems.length - 1;
    }
    if (Escape) {
      setOpen(false);
      setFocusOnNavButton();
    }
    if (ArrowUp) {
      var pos = currentMenuItemPosition - 1;
      if (currentMenuItemPosition > 0 && navMenuItems[pos]) {
        setCurrentMenuItemPosition(pos);
        navMenuItems[pos].focus();
      }
      if (pos < 0) {
        setCurrentMenuItemPosition(navMenuItemsBoundary);
        navMenuItems[navMenuItemsBoundary].focus();
      }
    }
    if (ArrowDown) {
      var _pos = currentMenuItemPosition === -1 ? 0 : currentMenuItemPosition + 1;
      if (currentMenuItemPosition < navMenuItemsBoundary && navMenuItems[_pos]) {
        navMenuItems[_pos].focus();
        setCurrentMenuItemPosition(_pos);
      }
      if (_pos >= navMenuItems.length) {
        setCurrentMenuItemPosition(0);
        navMenuItems[0].focus();
      }
    }
    if (Tab) {
      setOpen(false);
    }
    if (Home) {
      ev.preventDefault();
      setCurrentMenuItemPosition(0);
      navMenuItems[0].focus();
    }
    if (End) {
      ev.preventDefault();
      setCurrentMenuItemPosition(navMenuItemsBoundary);
      navMenuItems[navMenuItemsBoundary].focus();
    }
    if (Space) {
      ev.preventDefault();
      if (props.handleSelection) {
        props.handleSelection(selected);
      }
    }
  });
  (0, import_react.useEffect)(function() {
    if (props.handleSelection) {
      props.handleSelection(selected);
    }
  }, [selected]);
  (0, import_react.useEffect)(function() {
    if (menuRef.current) {
      var options = Array.from(menuRef.current.getElementsByTagName("li"));
      var focusableAnchorItems = options.map(function(li) {
        return li.firstElementChild;
      });
      setNavMenuItems(focusableAnchorItems);
    }
  }, [menuRef]);
  (0, import_useOnClickOutside.useOnClickOutside)(menuButtonContainerRef, function() {
    setOpen(false);
  });
  var handleClick = function handleClick2() {
    if (!disabled)
      setOpen(!open);
    return false;
  };
  return /* @__PURE__ */ import_react.default.createElement(NavigationMenuButtonContext.Provider, {
    value: dataContext
  }, /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButtonContainer, {
    ref: menuButtonContainerRef,
    "data-testid": "navigation-menu-container",
    className: props.className
  }, /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButton, {
    "aria-disabled": disabled,
    role: "combobox",
    "aria-controls": (0, import_utils.computedId)("navMenu", "list", props.id),
    "aria-expanded": open,
    "aria-haspopup": "menu",
    "aria-labelledby": props.label ? (0, import_utils.computedId)("navMenu", "label", props.id) : (0, import_utils.computedId)("navMenu", "placeholderLabel", props.id),
    className: "navigation__menubutton",
    darkMode,
    disabled,
    error: props.error,
    id: (0, import_utils.computedId)("navMenu", "menubutton", props.id),
    onClick: handleClick,
    "data-testid": "navigation-menu-button",
    ref: menuButtonRef,
    "data-dp-analytics-id": props.dataDpAnalyticsId
  }, /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButtonLayout, {
    className: "navigation__menubutton-layout"
  }, /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButtonIconContainer, {
    className: "navigation__menubutton-layout-icon-container"
  }, props.comboboxIcon && /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    color: darkMode ? import_baseTheme.default.colors.white : import_baseTheme.default.colors.black,
    icon: props.comboboxIcon,
    size: 18,
    className: "select__icon"
  })), /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButtonContent, null, props.label && /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledLabel, {
    id: (0, import_utils.computedId)("navMenu", "label", props.id),
    className: "select__label",
    darkMode,
    disabled
  }, props.label), selected ? /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledOptionText, {
    className: "navigation__menubutton-layout-selected",
    darkMode
  }, selected) : /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledOptionText, {
    id: (0, import_utils.computedId)("navMenu", "placeholderLabel", props.id),
    className: "navigation__menubutton-layout-placeholder",
    darkMode
  }, placeholder)), /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledMenuButtonIconContainer, {
    className: "navigation__menubutton-layout-icon-container"
  }, /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: open ? "chevron-up" : "chevron-down",
    color: darkMode ? import_baseTheme.default.colors.white : import_baseTheme.default.colors.pr.base,
    size: 20
  })))), /* @__PURE__ */ import_react.default.createElement(import_NavigationMenuButton.StyledOptionsList, _extends({
    "aria-labelledby": props.label ? (0, import_utils.computedId)("navMenu", "label", props.id) : (0, import_utils.computedId)("navMenu", "placeholderLabel", props.id),
    className: "menu__list",
    id: (0, import_utils.computedId)("navMenu", "list", props.id),
    role: "menu",
    "data-testid": "navigation-menu-list",
    ref: menuRef,
    isOpen: open,
    style: styles.popper
  }, attributes.popper), props.children)));
};
NavigationMenuButton.MenuItem = import_NavigationMenuItem.MenuItem;
var NavigationMenuButton_component_default = NavigationMenuButton;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  NavigationMenuButtonCtx
});
//# sourceMappingURL=NavigationMenuButton.component.js.map